import { OrganizationId } from '@kaizenplatform/hugot-entity';

import formatUrl from './formatUrl';

const getPointConfirmationLinkUrl = (baseUrl: string, organizationId: OrganizationId): string => {
  return formatUrl(baseUrl, `/account_setting/points`, { tab: 'history', org: organizationId });
};

export default getPointConfirmationLinkUrl;
